import { functionCallerInstallCommands } from "@p0security/integrations-aws-shared/policy/function-caller";
import { arnInfo } from "@p0security/integrations-aws-shared/util";
import { Typography } from "@p0security/ui";

import type { AwsInstaller } from "../types";

const functionCallerInstructions: AwsInstaller["components"]["function-caller"]["instructions"] =
  (context, id) => {
    const info = arnInfo(id);
    return {
      help: (
        <>
          To install P0 on this account, provision P0&apos;s access using{" "}
          <Typography.Link
            href={`https://${info.accountId}.signin.aws.amazon.com/console`}
            target="_blank"
            rel="noopener"
          >
            AWS Cloud Shell
          </Typography.Link>{" "}
          or Terraform:
        </>
      ),
      commands: {
        // TODO: Add IAC commands
        shell: [
          {
            command: functionCallerInstallCommands(context, {
              gcloudServiceAccountId: context.config.base[id]?.serviceAccountId,
              lambdaArn: id,
            }),
          },
        ],
      },
    };
  };

export const awsFunctionCallerInstaller: AwsInstaller["components"]["function-caller"] =
  {
    items: {},
    instructions: functionCallerInstructions,
  };
